import {
  createOperatorPassRevenue,
  fetchAllOperatorsPassRevenue,
  fetchAllPassRevenueCities,
  passRevenueUploadExcelFile,
} from "../../services/passRevenueService";
import {
  operatorPassRevenueCreated,
  clearOperatorPassRevenueList,
  setAllOperatorsPassRevenue,
  getPassRevenueCities,
  passRevenueUploadSheetFailure,
} from "../actions/passRevenueAction";
import { createAllActionCreators } from "./actionCreatorUtil";

export const clearOperatorPassRevenueAction = () => (dispatch) => {
  dispatch(clearOperatorPassRevenueList([]));
};

export const clearOperatorPassRevenueResponseAction = () => (dispatch) => {
  dispatch(operatorPassRevenueCreated({}));
};

const passRevenueActionCreators = {
  fetchAllOperatorPassRevenueAction: {
    service: fetchAllOperatorsPassRevenue,
    action: setAllOperatorsPassRevenue,
  },
  createOperatorPassRevenueAction: {
    service: createOperatorPassRevenue,
    action: operatorPassRevenueCreated,
    customApiResponse: (response, params) => ({
      success: true,
      isCloseModal: params.isCloseModal,
      response,
    }),
  },
  fetchPassRevenueCities: {
    service: fetchAllPassRevenueCities,
    action: getPassRevenueCities,
  },
  passRevenueUploadExcelFileAction: {
    service: passRevenueUploadExcelFile,
    responseNotification: {
      status: true,
      only: true,
    },
    responseNotificationMessage: (response) => response.messageResponse || "Upload successful",
    upload: {
      status: true,
      notificationMessage: "Upload Failed",
      errorAction: passRevenueUploadSheetFailure,
      errorActionMessage: (err) => (err.error
        ? `${err.message}: ${JSON.stringify(err.error)}`
        : err.message || "Something went wrong"),
    },
  },
};

export const {
  fetchAllOperatorPassRevenueAction,
  createOperatorPassRevenueAction,
  fetchPassRevenueCities,
  passRevenueUploadExcelFileAction,
} = createAllActionCreators(passRevenueActionCreators);
